import Numeral from "numeral";
import { useTranslation } from "next-i18next";

import Text from "ab-text";
import CTA from "ab-cta";
import Link from "ab-link";
import ParagraphText from "ab-paragraph-text";

import "./ab-product-detail.scss";

const ProductDetail = ({ producto, classname, invertir, imagen, i18n }) => {
  // console.log("ProductDetail", producto);
  const { t } = useTranslation("common", { i18n });

  return (
    <div
      className={`ab-product-detail ${classname || ""}${
        invertir ? " rtl" : ""
      }`}
    >
      <div
        className="image"
        style={{
          backgroundImage: `url(${imagen?.mediaItemUrl ||
            producto?.image?.mediaItemUrl})`,
        }}
      ></div>
      <div className="detail">
        <Text element="h2">{producto?.name}</Text>
        <Text element="span" className="title">
          {producto?.price ? Numeral(producto?.price).format("1,000.00$") : ""}
        </Text>
        <ParagraphText content={producto?.shortDescription} singleColumn />

        <div className="row">
          <CTA
            type="anadir"
            text={t("anadir")}
            selectedProduct={producto}
            i18n={i18n}
          />
          <Link
            prefetch={false}
            text={t("mas-info")}
            href={`${t("/tienda")}/${producto?.slug}`}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
